import React, { useContext } from "react"
import ReactDOM from "react-dom"
import { Input, Button } from "reactstrap"
import { MessageSquare, Menu, Star, Send, ChevronLeft } from "react-feather"
import PerfectScrollbar from "react-perfect-scrollbar"
import { ChatSocketContext } from "../../Networking/chatSocketContext";
import { connect } from "react-redux"
import moment from "moment"

class ChatLog extends React.Component {
  static getDerivedStateFromProps(props, state) {
    if (
      props.activeUser !== state.activeChat ||
      props.activeChat !== state.activeChat
    ) {
      return {
        activeUser: props.activeUser,
        activeChat: props.activeChat
      }
    }
    // Return null if the state hasn't changed
    return null
  }
  state = {
    msg: "",
    activeUser: null,
    activeChat: null,
    firstScroll: false,
    scrollY: 0,
  }

  handleSendMessage = (id, isPinned, text) => {
    if (text.length > 0) {
      this.context.sendMessage(id, isPinned, text)
      this.setState({
        msg: ""
      })
    }
  }
  componentDidMount() {
    this.scrollToBottom()
  }
  componentDidUpdate(prevProps, prevState) {
    if (!this.state.activeUser) {
      return
    }
    if (prevState.activeUser !== this.state.activeUser) {
      this.scrollToBottom()
      return
    }
    if (prevState.activeChat !== this.activeChat && this.context.chats[this.state.activeUser.uid].msg.length > 1) {
      if (this.state.firstScroll == false) {
        this.scrollToBottom()
        this.setState({
          firstScroll: true
        })
      }
      else {
        const chatContainer = ReactDOM.findDOMNode(this.chatArea)
        // console.log(chatContainer.scrollHeight - this.state.scrollY)
        console.log(this.state.scrollY)
        chatContainer.scrollTop = chatContainer.scrollHeight - this.state.scrollY
      }
    }

    if (prevState.activeUser !== this.state.activeUser) {
      this.setState({
        firstScroll: false
      })
    }
  }

  handleDate = (time_to, time_from) => {
    const date_time_to = new Date(Date.parse(time_to))
    const date_time_from = new Date(Date.parse(time_from))
    return (
      date_time_to.getFullYear() === date_time_from.getFullYear() &&
      date_time_to.getMonth() === date_time_from.getMonth() &&
      date_time_to.getDate() === date_time_from.getDate()
    )
  }

  handleTime = (time_to, time_from) => {
    const date_time_to = new Date(Date.parse(time_to))
    const date_time_from = new Date(Date.parse(time_from))
    return (
      date_time_to.getFullYear() === date_time_from.getFullYear() &&
      date_time_to.getMonth() === date_time_from.getMonth() &&
      date_time_to.getDate() === date_time_from.getDate() &&
      date_time_to.getHours() === date_time_from.getHours() &&
      date_time_to.getMinutes() === date_time_from.getMinutes()
    )
  }

  scrollToBottom = () => {
    const chatContainer = ReactDOM.findDOMNode(this.chatArea)
    chatContainer.scrollTop = chatContainer.scrollHeight
  }

  render() {
    const { activeUser } = this.state
    let activeUserUid = activeUser && activeUser.uid ? activeUser.uid : null,
      activeChat =
        activeUser && activeUser.uid
          ? this.context.chats[activeUserUid]
          : null

    let renderChats =
      activeChat && activeChat !== undefined && activeChat.msg
        ? activeChat.msg.map((chat, i) => {
          let renderSendTime = () => {
            if (
              activeChat.msg[i+1] &&
              (!this.handleTime(chat.time, activeChat.msg[i + 1].time)) ||

              !activeChat.msg[i+1]
            ) {
              return (
                <div className="chat-content" style={{ marginRight: 10, marginTop: -16, background: 'transparent', boxShadow: 'none', fontSize: this.props.isMini ? 16 : '' }}>
                  <span style={{ fontSize: 12, color: '#aeacb2' }}>{moment(new Date(activeChat.msg[i].time)).format("HH:mm")}</span>
                </div>
              )
            }
          }
          let renderSentDate = () => {
            if (
              (i > 0 &&
                !this.handleDate(chat.time, activeChat.msg[i - 1].time)) ||
              i == 0
            ) {
              return (
                <div className="divider">
                  <div className="divider-text">
                    {new Date(activeChat.msg[i].time).getDate() +
                      " " +
                      new Date(activeChat.msg[i].time).toLocaleString("default", {
                        month: "short"
                      })}
                  </div>
                </div>
              )
            }
          }
          let renderAvatar = () => {
            if (i > 0) {
              if (
                chat.isSent === true &&
                activeChat.msg[i - 1].isSent !== true
              ) {
                return (
                  <div className="chat-avatar">
                    <div className="avatar m-0">
                      <img
                        src={this.props.clinicUserinfo.profileImagePath}
                        alt="chat avatar"
                        height="40"
                        width="40"
                      />
                    </div>
                  </div>
                )
              } else if (chat.isSent !== true) {
                return (
                  <div className="chat-avatar">
                    <div className="avatar m-0">
                      <img
                        src={activeUser.photoURL}
                        alt="chat avatar"
                        height="40"
                        width="40"
                      />
                    </div>
                  </div>
                )
              } else {
                return ""
              }
            } else {
              return (
                <div className="chat-avatar">
                  <div className="avatar m-0">
                    <img
                      src={chat.isSent ? this.props.clinicUserinfo.profileImagePath : activeUser.photoURL}
                      alt="chat avatar"
                      height="40"
                      width="40"
                    />
                  </div>
                </div>
              )
            }
          }
          return (
            <React.Fragment key={i}>
              {renderSentDate()}
              <div
                className={`chat ${chat.isSent !== true ? "chat-left" : "chat-right"
                  }`}>
                {renderAvatar()}
                <div className="chat-body">
                  <div className="chat-content" style={{ fontSize: this.props.isMini ? 16 : '' }}>
                    {chat.textContent}
                  </div>
                  {renderSendTime()}
                </div>
              </div>
            </React.Fragment>
          )
        })
        : null

    return (
      <div className={" " + (this.props?.isMini ? "sidebar-content content-left mini-chat" : "content-right")}>
        <div className="chat-app-window">
          <div
            className={`start-chat-area ${activeUser !== null ? "d-none" : "d-flex"
              }`}>
            <span className="mb-1 start-chat-icon">
              <MessageSquare size={50} />
            </span>
            <h4
              className="py-50 px-1 sidebar-toggle start-chat-text"
              onClick={() => {
                if (this.props.mql.matches === false) {
                  this.props.mainSidebar(true)
                } else {
                  return null
                }
              }}>
              Bir Mesaj Başlat
            </h4>
          </div>
          <div
            className={`active-chat ${activeUser === null ? "d-none" : "d-block"
              }`}>
            <div className="chat_navbar" style={{ backgroundColor: 'white' }}>
              <header className="chat_header d-flex justify-content-between align-items-center p-1">
                {this.props?.isMini &&
                  <span
                    role="button"
                    onClick={() => {
                      this.props.handleActiveChat(
                        null,
                        null,
                        null
                      )
                    }}>
                    <ChevronLeft />
                  </span>
                }
                <div className="d-flex align-items-center">
                  {/* <div
                    className="sidebar-toggle d-block d-lg-none mr-1"
                    onClick={() => this.props.mainSidebar(true)}>
                    <Menu size={24} />
                  </div> */}
                  {this.props?.isMini &&
                    <h6 className="mr-2 mb-0">
                      {activeUser !== null ? activeUser.displayName : ""}
                    </h6>
                  }
                  <div className="avatar user-profile-toggle m-0 m-0 mr-1">
                    <img
                      src={activeUser !== null ? activeUser.photoURL : ""}
                      alt={activeUser !== null ? activeUser.displayName : ""}
                      height="40"
                      width="40"
                    />
                    {/* <span
                      className={`
                    ${
                      activeUser !== null &&
                      activeUser.status === "do not disturb"
                        ? "avatar-status-busy"
                        : activeUser !== null && activeUser.status === "away"
                        ? "avatar-status-away"
                        : activeUser !== null && activeUser.status === "offline"
                        ? "avatar-status-offline"
                        : "avatar-status-online"
                    }
                    `}
                    /> */}
                  </div>
                  {!this.props?.isMini &&
                    <h6 className="mb-0">
                      {activeUser !== null ? activeUser.displayName : ""}
                    </h6>
                  }

                </div>
                {/* <span
                  className="favorite"
                  onClick={() => {
                    if (activeChat) {
                      this.props.togglePinned(
                        activeUser.uid,
                        !activeChat.isPinned
                      )
                    }
                  }}>
                  <Star
                    size={22}
                    stroke={
                      activeChat && activeChat.isPinned === true
                        ? "#FF9F43"
                        : "#626262"
                    }
                  />
                </span> */}
              </header>
            </div>
            <PerfectScrollbar
              onScrollY={container => {
                this.setState({
                  scrollY: container.scrollHeight - container.scrollTop
                })
                if (container.scrollTop <= 100) {
                  this.context.checkMessages(activeUser.uid, false)
                }
              }}
              className="user-chats"
              options={{
                suppressScrollX: true,
                // suppressScrollY: this.props.isMini ? true : false,
                maxScrollbarLength: 0,
                useBothWheelAxes: false,
                wheelPropagation: false
              }}
              ref={el => {
                this.chatArea = el;
                this.context.scrollRef = el;
              }}>
              {this.props.isMini &&
                <style>
                  {`
                  .ps__rail-y{
                    display: none !important;
                  }
                  `}
                </style>
              }
              <div className="chats">{renderChats}</div>
            </PerfectScrollbar>
            <div className="chat-app-form">
              <form
                className="chat-app-input d-flex align-items-center"
                onSubmit={e => {
                  e.preventDefault()
                  this.handleSendMessage(
                    activeUser.uid,
                    false,
                    this.state.msg,
                    activeUser
                  )
                }}>
                <Input
                  type="text"
                  className="message mr-1 ml-50"
                  placeholder="Mesaj yazın..."
                  value={this.state.msg}
                  onChange={e => {
                    e.preventDefault()
                    this.setState({
                      msg: e.target.value
                    })
                  }}
                />
                <Button color="primary">
                  <Send className="d-lg-none" size={15} />
                  <span className="d-lg-block d-none">Gönder</span>
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ChatLog.contextType = ChatSocketContext;
const mapStateToProps = state => {
  return {
    clinicUserinfo: state.clinicUser.clinicUserinfo
  }
}
export default connect(mapStateToProps, {})(ChatLog)